import { FreetrialsSteps, TryNowProductsIds } from './types';

export const TRY_NOW_PRODUCTS_IDS: TryNowProductsIds = {
  CAPTURE_CLIENT: '401',
  CLOUD_APP_SECURITY_BROKER: '402',
  SONICWALL_CLOUD_EDGE: '403',
  CLOUD_EMAIL_SECURITY: '404',
  SONICWALL_CLIENT_LICENSE_PRODUCT: '298',
  HOSTED_EMAIL_SECURITY: '300',
  SONICWALL_CLOUD_SECURE_EDGE: '409',
  THERON: '410',
  SONICWALL_AI: '411',
  THERON_MDR: '412',
} as const;

export const DOMAIN_INFO_REQUIRED_PRODUCTS: String[] = [
  TRY_NOW_PRODUCTS_IDS.CLOUD_APP_SECURITY_BROKER,
  TRY_NOW_PRODUCTS_IDS.SONICWALL_CLOUD_EDGE,
];

export const STEPS: FreetrialsSteps = {
  ENTER_FRIENDLY_NAME_OR_DOMAIN_NAME_STEP: 'ENTER_FRIENDLY_NAME_OR_DOMAIN_NAME_STEP',
  CHOOSE_DATA_CENTER_STEP: 'CHOOSE_DATA_CENTER_STEP',
  CHOOSE_CASB_APP_STEP: 'CHOOSE_CASB_APP_STEP',
  CHOOSE_DATA_CENTER_AND_SUB_DOMAIN_NAME_STEP: 'CHOOSE_DATA_CENTER_AND_SUB_DOMAIN_NAME_STEP',
} as const;

export const isValidCasbFriendlyName = (friendlyName: string) => {
  const casbfriendlyNamePattern = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]$');
  if (casbfriendlyNamePattern.test(friendlyName)) {
    return true;
  }
  return false;
};

export const isValidCSEOrgName = (orgName: string): boolean => {
  const orgNamePattern = /^[a-z0-9-]+$/;
  return orgNamePattern.test(orgName);
};

export const isCSEOrgNameLengthValid = (orgName: string): boolean => {
  return orgName.length >= 4 && orgName.length <= 30;
};

export const isCSEOrgStartsWith = (orgName: string): boolean => {
  const startsWithLetter = /^[a-z]/;
  return startsWithLetter.test(orgName);
};
